module.exports = __webpack_public_path__ + "static/media/website_under_construction1.9f696d06.png";